define.alias("ember-composable-helpers/helpers/sort-by", "settings/helpers/sort-by");